export default () =>{
    const moreWrapper = document.querySelector('[home-more]');
    moreWrapper?hoverAnimate():false;

    function hoverAnimate(){
        const linkArr = moreWrapper.querySelectorAll('[more-link]');
        const fadeBox = moreWrapper.querySelector('.home-more__lnks-container');

        linkArr.forEach(link =>{
            link.addEventListener('mouseenter', ()=>{
                if (!fadeBox.classList.contains('hovered')){
                    fadeBox.classList.add('hovered');
                }
            })
            link.addEventListener('mouseleave', ()=>{
                fadeBox.classList.remove('hovered');
            })
        })
    }  
}